import React from "react";
import { List, ListItem } from "@material-ui/core";

var ProList = function ProList(_a) {
  var options = _a.options,
      selected = _a.selected,
      onChange = _a.onChange;
  return React.createElement(List, {
    style: {
      maxHeight: 310,
      width: 227
    }
  }, options.map(function (item, idx) {
    return React.createElement(ListItem, {
      selected: selected === item.value,
      key: idx,
      onClick: function onClick() {
        return onChange(item);
      },
      button: true,
      disabled: item.disabled
    }, item.label);
  }));
};

export default ProList;